import { EXTERNAL_WEBSITE_LINK } from 'components/footer/Footer';
import React, { Component } from 'react';
import sanitizeHtml from 'sanitize-html';
import { t } from 'utils/language';

type Props = {
  buttonLabel: string
};

class TermsAndConditions extends Component<Props> {
  buildTermsOfUseMarkup() {
    const { buttonLabel } = this.props;
    const termsOfUseLink = `${EXTERNAL_WEBSITE_LINK}/terms-and-conditions`;
    const privacyNoticeLink = `${EXTERNAL_WEBSITE_LINK}/privacy-notice/`;

    const params = {
      terms_and_conditions:
        `<a class="signup__tos-link" target="_blank" href="${termsOfUseLink}">${t('terms_and_conditions')}</a>`,
      privacy_notice:
        `<a class="signup__tos-link" target="_blank" href="${privacyNoticeLink}">${t('privacy_notice')}</a>`,
      signup_action: buttonLabel
    };

    return sanitizeHtml(t('signup_terms_of_use', params), {
      allowedAttributes: {
        a: ['href', 'target', 'class']
      }
    });
  }

  render() {
    return (
      <small
        className="signup__tos"
        dangerouslySetInnerHTML={{ __html: this.buildTermsOfUseMarkup() }}
      />
    );
  }
}

export default TermsAndConditions;
